import { render, staticRenderFns } from "./MdKpiCard.vue?vue&type=template&id=488ee690&scoped=true&"
import script from "./MdKpiCard.vue?vue&type=script&lang=js&"
export * from "./MdKpiCard.vue?vue&type=script&lang=js&"
import style0 from "./MdKpiCard.vue?vue&type=style&index=0&id=488ee690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ee690",
  null
  
)

export default component.exports